import { css } from "@emotion/core";
import {
  color,
  fontWeight,
  fontSizes,
  fontTypes,
} from "../../constants/commons";

export const signupStyle = css`

.extra-communication-box {
  display: flex;
  align-items: start;
  font-family:${fontTypes.meduim};
  .whatsapp-img{
    width: 2em;
    margin-right: 10px;
  }
  .checkbox-container{
    padding-top: 4px;
  }
}

.spinner-loading {
  text-align: center;
  margin: 50% 0em;
}
.extra-info {
  .info-container {
    width: 100%;
    .info-box {
      border-radius: 10px;
    }
  }
  .info-box {
    text-align: left;
  }
  .info-box-data {
    .title {
      justify-content: left;
    }
  }
}

.align-row {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 2em;
}

.login-button-style {
  color: ${color.red};
  font-family: ${fontTypes.bold};
  font-weight: ${fontWeight.light};
}
.errorcomponent-login-button-style{
  padding: 0.5em 8em;
}
.error-description-style {
  color: ${color.lightishBlue};
  font-family: ${fontTypes.meduim};
  font-weight: ${fontWeight.medium};
  text-align: center;
}
  .profile-message-style{
    font-weight: ${fontWeight.medium};
    font-size: ${fontSizes.xxs};
    color: ${color.lightishGray};
  }
  .ant-input-group.ant-input-group-compact {
    display: flex;
    align-items: center;
    font-size: ${fontTypes.meduim};
    font-weight: ${fontWeight.medium};
  }

  .margin-bottom-style {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 85%;
  }
 
  .ant-select-selection.ant-select-selection--single {
    border-left: none;
    border-top: none;
    border-right: none;
  }
  .ant-tabs-ink-bar {
    background: ${color.red};
    border-radius: 0.125em;
    height: 0.25em;
  }
  .ant-tabs-nav .ant-tabs-tab:hover {
    color: ${color.black};
  }
  .ant-tabs-nav .ant-tabs-tab {
    margin: 0 1.45em 0 0;
    padding: 0.2em 0 0.85em 0;
    font-size: ${fontSizes.xs};
    font-family: ${fontTypes.bold};
    font-weight: ${fontWeight.medium};
  }
  .ant-tabs-nav .ant-tabs-tab-active {
    color: ${color.black};
    font-size: ${fontSizes.sm};
    font-family: ${fontTypes.bold};
    font-weight: ${fontWeight.medium};
  }

  .circle-dot {
    background: ${color.white};
    height: 1.625em;
    width: 1.625em;
    border-radius: 1.75em;
    color: ${color.black};
  }

  .inner-circle-font {
    color: ${color.lighterGray};
    font-weight: ${fontWeight.medium};
    height: 1.375em;
  }

 
  }

  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .responsive-font-size {
      font-size: ${fontSizes.xxs};
    }
    .heading-style {
      font-size: ${fontSizes.xlg};
      font-family: ${fontTypes.bold};
      font-weight: ${fontWeight.light};
    }
    .responsive-dimensions {
      min-height: 22.5em;
    }
    .mobile-responsive-width{
      width: 10em;
    }
  }

  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .responsive-font-size {
      font-size: ${fontSizes.xxs};
    }
    .heading-style {
      font-size: ${fontSizes.xlg};
      font-family: ${fontTypes.bold};
      font-weight: ${fontWeight.light};
    }
   
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .responsive-dimensions {
      min-height: 42em;
      position: relative;
    }
    .responsive-fixed-bottom {
      position: absolute;
      bottom: 0;
    }
    .responsive-font-size {
      font-size: ${fontSizes.xs};
    }
    .heading-style {
      font-size: ${fontSizes.xlg};
      font-family: ${fontTypes.bold};
      font-weight: ${fontWeight.light};
    }
   
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    .responsive-dimensions {
      min-height: 42em;
      position: relative;
    }
    .responsive-fixed-bottom {
      position: absolute;
      bottom: 0;
    }
    .heading-style {
      font-size: ${fontSizes.xxlg};
      font-family: ${fontTypes.bold};
      font-weight: ${fontWeight.light};
    }
    // .desktop-footer-style{
    //   position: absolute;
    //   width: 100%;
    //   bottom: 1em;
    // }
    .button-width {
      width: 33%
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .responsive-dimensions {
      min-height: 42em;
      position: relative;
    }
    .responsive-fixed-bottom {
      position: absolute;
      bottom: 0;
    }
    .heading-style {
      font-size: ${fontSizes.xxlg};
      font-family: ${fontTypes.bold};
      font-weight: ${fontWeight.light};
    }
    // .desktop-footer-style{
    //   position: absolute;
    //   width: 100%;
    //   bottom: 2.2em;
    // }
    .button-width {
      width: 50%
    }
  }
`;
